import { Step } from 'signup-constants/Step';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
export const BranchACQ0173 = {
  name: 'BranchACQ0173',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0173, [ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Variant_C]);
  },
  rebuildFlow: () => {
    const {
      preVerification
    } = getFlowSteps();

    // We need to add the Password step before the LoadingPage step because
    // to ensure the flow length is greater than 1 so that the end of signup logic isn't triggered
    const nextSteps = [...(isPreVerification() ? preVerification : []), Step.LoadingPage, Step.Password];
    return nextSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};